import QuotationError from './QuotationError';
class QuotationNumberOfBricksMinimun extends QuotationError {
    constructor(options) {
        super('The number of bricks is under the minimun to buy', options);
    }
}
// eslint-disable-next-line import/no-unused-modules
export default QuotationNumberOfBricksMinimun;
